export const TRANSLATIONS_FR_HOME_PULSE_AND_CALENDAR = {
  "home.pulse.eyebrow": "Moteur de classification en direct",
  "home.pulse.subtitle": "Nous suivons en direct la façon dont Innovadoc IA étiquette vos documents.",
  "home.pulse.originNote": "Toutes les dates, priorités et actions affichées ici proviennent de ce flux de classification.",
  "home.pulse.state.ok": "Tout est clair",
  "home.pulse.state.processing": "Attention requise",
  "home.pulse.state.attention": "Critique",
  "home.pulse.summary.documents": "Documents déjà compris",
  "home.pulse.summary.artifacts": "Types d'artéfact cartographiés",
  "home.pulse.summary.categories": "Catégories reconnues",
  "home.pulse.summary.overdue": "En retard",
  "home.pulse.summary.upcoming": "À venir",
  "home.pulse.modal.eyebrow": "Dates clés",
  "home.pulse.modal.overdueTitle": "Documents en retard",
  "home.pulse.modal.upcomingTitle": "Documents à venir",
  "home.pulse.modal.countLabel": "Affichage",
  "home.pulse.modal.ofLabel": "sur",
  "home.pulse.modal.dueLabelOverdue": "En retard depuis",
  "home.pulse.modal.dueLabelUpcoming": "Échéance",
  "home.pulse.modal.roleLabel": "Rôle",
  "home.pulse.modal.stateLabel": "Statut",
  "home.pulse.modal.actionLabel": "Action",
  "home.pulse.modal.close": "Fermer",
  "home.pulse.modal.viewDocument": "Voir le document",
  "home.pulse.modal.openQueue": "Voir les priorités",
  "home.pulse.modal.overdueEmpty": "Aucun document en retard.",
  "home.pulse.modal.upcomingEmpty": "Aucun document à venir.",
  "home.pulse.modal.limitedHint": "Liste abrégée. Voir vos priorités pour tout afficher.",
  "home.pulse.artifactTypes.title": "Types d'artéfact détectés",
  "home.pulse.artifactTypes.showMore": "Voir plus",
  "home.pulse.artifactTypes.showLess": "Voir moins",
  "home.pulse.recentClassifications.title": "Classifications récentes",
  "home.pulse.recentClassifications.countLabel": "entrées",
  "home.pulse.recentClassifications.empty": "Aucune classification durant la dernière heure.",
  "home.pulse.empty": "Aucune donnée de pulse disponible.",
  "home.datesSummary.eyebrow": "Dates importantes",
  "home.datesSummary.title": "Dates importantes de vos documents",
  "home.datesSummary.totalLabel": "documents avec des échéances proches",
  "home.datesSummary.description": "Renouvellements et échéances à venir à ne pas perdre de vue.",
  "home.datesSummary.connection": "Classées par échéance la plus proche.",
  "home.datesSummary.roleLabel": "Responsable",
  "home.datesSummary.role.renewal": "Renouvellements",
  "home.datesSummary.role.audit": "Audits",
  "home.datesSummary.role.expiration": "Échéances",
  "home.datesSummary.role.compliance": "Conformité",
  "home.datesSummary.tooltip": "Détectées automatiquement dans vos documents.",
  "home.datesSummary.clearFilter": "Effacer le filtre par rôle",
  "home.datesSummary.panelEyebrow": "Dates importantes",
  "home.datesSummary.panelTitle": "Dates importantes de vos documents",
  "home.datesSummary.panelSubtitle": "Documents et leurs échéances proches à passer en revue.",
  "home.datesSummary.closePanel": "Fermer le panneau des dates",
  "home.datesSummary.panelQueueCta": "Voir ces documents",
  "home.datesSummary.panelFilterActive": "Filtre actif : uniquement ce rôle.",
  "home.datesSummary.panelEmpty": "Aucune date détectée à afficher.",
  "home.datesSummary.empty": "Aucune date détectée pour le moment.",
  "home.datesSummary.filterSaved": "Préférence enregistrée.",
  "home.datesSummary.state.active": "Active",
  "home.datesSummary.state.upcoming": "À venir",
  "home.datesSummary.state.resolved": "Résolue",
  "home.datesSummary.previewTitle": "Échéances à venir",
  "home.datesSummary.previewSubtitle": "par échéance",
  "home.datesSummary.previewAction": "Voir la liste",
  "home.datesSummary.previewChangeRole": "Changer de responsable",
  "home.datesSummary.previewOpenCalendar": "Ouvrir le calendrier",
  "home.stats.title": "Comment le système comprend vos documents aujourd'hui",
  "home.stats.description": "Ces métriques garantissent que la classification reste saine.",
  "home.stats.note": "Elles soutiennent chaque recommandation et vos priorités.",
  "home.stats.label.pending_documents": "Documents en attente",
  "home.stats.label.evaluated_documents": "Documents évalués",
  "home.stats.label.oldest_pending_age_seconds": "Ancienneté du plus ancien en attente (secondes)",
  "home.stats.label.last_evaluation_age_seconds": "Ancienneté de la dernière évaluation (secondes)",
  "home.stats.label.evaluation_duration_p95_ms": "Durée d'évaluation p95 (ms)",
  "home.stats.label.evaluation_duration_p99_ms": "Durée d'évaluation p99 (ms)",
  "home.stats.label.ranker_duration_p95_ms": "Durée ranker p95 (ms)",
  "home.stats.label.ranker_duration_p99_ms": "Durée ranker p99 (ms)",
  "home.stats.label.error_rate": "Taux d'erreur",
  "home.stats.label.throughput_eval_per_hour": "Évaluations par heure",
  "home.stats.label.throughput_rank_per_hour": "Classement par heure",
  "home.stats.empty": "Aucune métrique disponible pour le moment.",
  "home.decisionPulse.eyebrow": "Pouls opérationnel",
  "home.decisionPulse.headline.alert": "Certaines décisions demandent une attention immédiate",
  "home.decisionPulse.headline.watch": "La charge est stable, mais des décisions approchent",
  "home.decisionPulse.headline.calm": "Tout est sous contrôle pour l'instant",
  "home.decisionPulse.copy.actNow": "demandent une action immédiate",
  "home.decisionPulse.copy.overdue": "sont en retard",
  "home.decisionPulse.copy.actSoon": "devraient être traitées bientôt",
  "home.decisionPulse.copy.monitoring": "décisions restent sous surveillance",
  "home.decisionPulse.copy.empty": "Il n'y a aucune décision active pour le moment.",
  "home.decisionPulse.connection.label": "SSE",
  "home.decisionPulse.connection.connecting": "Connexion",
  "home.decisionPulse.connection.connected": "Temps réel",
  "home.decisionPulse.connection.disconnected": "Déconnecté",
  "home.decisionPulse.connection.error": "Avec retard",
  "home.calendar.eyebrow": "Calendrier",
  "home.calendar.title": "Calendrier des décisions",
  "home.calendar.description": "Parcourez les décisions par date d'échéance tout en conservant le panneau de détail existant.",
  "home.calendar.empty": "Aucune décision datée pour cette période.",
  "home.calendar.emptyMonth": "Aucune décision datée",
  "home.calendar.undated": "Décisions sans date",
  "home.calendar.today": "Aujourd'hui",
  "home.calendar.previous": "Précédent",
  "home.calendar.next": "Suivant",
  "home.calendar.moreEntries": "de plus",
  "home.calendar.emptyDay": "Aucun événement suivi ce jour-là.",
  "home.calendar.granularity.week": "Semaine",
  "home.calendar.granularity.month": "Mois",
  "home.calendar.granularity.year": "Année",
  "home.knowledgeExpirations.title": "Échéances documentaires à venir",
  "home.knowledgeExpirations.viewAll": "Tout voir",
  "home.knowledgeExpirations.empty": "Aucune échéance à venir dans vos documents.",
  "home.knowledgeExpirations.errorTitle": "Impossible de charger les échéances",
  "home.knowledgeExpirations.errorMessage": "Veuillez réessayer dans quelques secondes.",
  "home.knowledgeEntities.title": "Entités avec activité récente",
  "home.knowledgeEntities.viewAll": "Explorer",
  "home.knowledgeEntities.sources": "sources",
  "home.knowledgeEntities.empty": "Aucune entité avec activité récente pour le moment.",
  "home.knowledgeEntities.errorTitle": "Impossible de charger les entités",
  "home.knowledgeEntities.errorMessage": "Veuillez réessayer dans quelques secondes.",
  "home.calendar.agenda.empty": "Aucune décision planifiée ce mois-ci.",
  "home.calendar.agenda.today": "Aujourd'hui",
  "home.calendar.agenda.todayBadge": "Aujourd'hui",
  "home.calendar.agenda.previousMonth": "Mois précédent",
  "home.calendar.agenda.nextMonth": "Mois suivant",
  "home.viewMode.label": "Mode d'affichage",
};
